import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteCoursePurchase, getCoursePurchases, getCoursePurchasesBill } from "../../redux/services/coursePurchaseSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { getCourses } from "../../redux/services/courseSlice";
import { PiFilePdf } from "react-icons/pi";

const CoursePurchase = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getPurchaseData = useSelector((state) => state?.coursePurchase?.coursePurchaseData);
  const getPurchaseBill = useSelector((state) => state?.coursePurchase?.coursePurchaseBillData);
  const getCourseData = useSelector((state) => state?.course?.courseData?.course_data);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [courseFilter, setCourseFilter] = useState("");
  const [courseBill, setCourseBill] = useState("");

  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllCourses = useCallback(async () => {
    try {
      await dispatch(getCourses({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllCourses();
  }, [getAllCourses]);

  const filterOptions = [
    { value: "", label: "All" },
    ...(getCourseData
      ? getCourseData?.map((course) => ({
          value: course?._id,
          label: course?.title,
        }))
      : ""),
  ];

  const getAllPurchases = useCallback(async () => {
    try {
      await dispatch(getCoursePurchases({ page: page + 1, limit: pageLimit, searchData, courseId: courseFilter }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData, courseFilter]);

  useEffect(() => {
    getAllPurchases();
  }, [getAllPurchases]);

  const deletePurchase = async () => {
    try {
      const response = await dispatch(deleteCoursePurchase(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllPurchases();
    } catch (error) {}
  };

  const getPurchasesBill = useCallback(async () => {
    try {
      await dispatch(getCoursePurchasesBill({ courseId: courseBill }));
    } catch (error) {}
  }, [dispatch, courseBill]);

  useEffect(() => {
    if (courseBill) {
      getPurchasesBill();
    }
  }, [courseBill, getPurchasesBill]);

  const columns = [
    { header: "S/N", key: "index", render: (_, __, index) => page * pageLimit + index + 1 },
    {
      header: "Course Name",
      key: "courseId",
      render: (course) => course?.title,
    },
    { header: "Name", key: "name" },
    { header: "Phone", key: "phone" },
    { header: "Email", key: "email" },
    { header: "City", key: "city" },
    { header: "Amount", key: "amount" },
    { header: "Referral Code", key: "referralCode", render: (referralCode) => (referralCode ? referralCode : "-") },
    { header: "Reach From", key: "reachFrom", render: (reachFrom) => (reachFrom ? reachFrom : "-") },
    { header: "Payment ID", key: "paymentId" },
    { header: "Status", key: "status" },
    {
      header: "Enroll Date",
      key: "createdAt",
      render: (value) => (value ? new Date(value).toLocaleDateString() : "—"),
    },
    {
      header: "Payment Date",
      key: "paymentDate",
      render: (value) => (value ? new Date(value).toLocaleDateString() : "—"),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.COURSES.PURCHASE_EDIT}?purchaseId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
    {
      icon: <PiFilePdf className="w-6 h-6" />,
      onClick: (row) => {
        if (row.billPdfUrl) {
          window.open(row.billPdfUrl, "_blank");
        } else {
          setCourseBill(row._id);
        }
      },
    },
  ];
  useEffect(() => {
    if (getPurchaseBill) {
      window.open(getPurchaseBill, "_blank");
      setCourseBill("");
      getAllPurchases();
    }
  }, [getPurchaseBill]);
  return (
    <>
      <Table
        title="Course Purchase"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        columns={columns}
        data={getPurchaseData?.course_purchase_data || []}
        actions={actions}
        filterOptions={filterOptions}
        onFilterChange={(e) => {
          setCourseFilter(e ? e.value : "");
        }}
        pageCount={getPurchaseData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && <ConfirmationPage topicName="Course Purchase" confirm={confirm} onDelete={deletePurchase} onCancel={() => setConfirm(false)} />}
    </>
  );
};

export default CoursePurchase;
